import React from 'react';
import List from '@mui/material/List';
import { LayersNestedListProps } from 'types/mainPage';
import { LayersNestedListItem } from '../LayersNestedListItem';

export const LayersNestedList: React.FC<LayersNestedListProps> = ({
  list,
  nesting = 1,
  parent,
  ...props
}): JSX.Element => {
  return (
    <List
      sx={{ width: '100%', bgcolor: 'background.paper' }}
      aria-labelledby="nested-list-subheader"
    >
      {list.map((item, index) => {
        return (
          <LayersNestedListItem
            url={item.url}
            layerId={item.id}
            system_name={item.layer}
            key={String(item.id) + index}
            title={item.name}
            children={item.children}
            parent={(item.children && item.name) || parent}
            firstParent={item.firstParent}
            nesting={nesting}
            legendUrl={item.legend_file}
            mapFileUrl={item.map_file}
            tooltipText={item.msg}
            legend_size={item.legend_size}
            dynamic_series={item.dynamic_series}
            scale_1_50={item.scale_1_50}
            meta_file={item.meta_file}
            scale_1_50_vector={item.scale_1_50_vector}
            {...props}
          />
        );
      })}
    </List>
  );
};
